
import { supabaseChatGroupService } from './supabase/chatGroupService';
import { supabaseChatGroupUsersService } from './supabase/chatGroupUsersService';
import { supabaseChatMessagesService } from './supabase/chatMessagesService';
import { supabaseUserSearchService } from './supabase/userSearchService';

// Main Supabase chat service that combines all sub-services
export const supabaseChatService = {
  // Chat group operations
  createChatGroup: supabaseChatGroupService.createChatGroup,
  getUserChatGroups: supabaseChatGroupService.getUserChatGroups,
  deleteChatGroup: supabaseChatGroupService.deleteChatGroup,

  // Chat group users operations
  addUsersToGroup: supabaseChatGroupUsersService.addUsersToGroup,
  getChatGroupUsers: supabaseChatGroupUsersService.getChatGroupUsers,
  leaveGroup: supabaseChatGroupUsersService.leaveGroup,

  // Message operations
  getChatMessages: supabaseChatMessagesService.getChatMessages,
  sendMessage: supabaseChatMessagesService.sendMessage,
  markMessagesAsRead: supabaseChatMessagesService.markMessagesAsRead,

  // User operations
  searchUsers: supabaseUserSearchService.searchUsers,
  getAllUsers: supabaseUserSearchService.getAllUsers
};
